import _ from 'lodash';
import {
  CREATE_STORYBOARD_REQUEST, CREATING_STORYBOARD_SUCCEEDED, CREATING_STORYBOARD_FAILED,
  UPDATE_STORYBOARD_REQUEST, UPDATING_STORYBOARD_SUCCEEDED, UPDATING_STORYBOARD_FAILED,
  FETCH_STORYBOARDS_REQUEST, FETCHING_STORYBOARDS_SUCCEEDED, FETCHING_STORYBOARDS_FAILED,
  FETCH_STORYBOARD_REQUEST, FETCHING_STORYBOARD_SUCCEEDED, FETCHING_STORYBOARD_FAILED,
  DELETE_STORYBOARD_REQUEST, DELETING_STORYBOARD_SUCCEEDED, DELETING_STORYBOARD_FAILED,
  CLONE_STORYBOARD_REQUEST, CLONING_STORYBOARD_SUCCEEDED, CLONING_STORYBOARD_FAILED,

  CREATE_GATING_CONFIG_REQUEST, UPDATE_GATING_CONFIG_REQUEST, DELETE_GATING_CONFIG_REQUEST, RESET_GATING_CONFIG_REQUEST,

  FETCH_STORYBOARD_USERS, FETCHING_STORYBOARD_USERS_SUCCEEDED, FETCHING_STORYBOARD_USERS_FAILED,
  ADD_USERS_TO_STORYBOARD, ADD_USERS_TO_STORYBOARD_SUCCEEDED, ADD_USERS_TO_STORYBOARD_FAILED,
  UPDATE_STORYBOARD_USER_ACCESS, UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED, UPDATE_STORYBOARD_USER_ACCESS_FAILED,
  REMOVE_USER_FROM_STORYBOARD, REMOVE_USER_FROM_STORYBOARD_SUCCEEDED, REMOVE_USER_FROM_STORYBOARD_FAILED,

  FETCHING_STORYBOARD_REPORT_SUMMARY, FETCHING_STORYBOARD_REPORT_SUMMARY_SUCCEEDED, FETCHING_STORYBOARD_REPORT_SUMMARY_FAILED,
  FETCHING_STORYBOARD_VISITORS_REPORTS, FETCHING_STORYBOARD_VISITORS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_VISITORS_REPORTS_FAILED,
  FETCHING_INTERACTIVE_PAGES_REPORTS, FETCHING_INTERACTIVE_PAGES_REPORTS_SUCCEEDED, FETCHING_INTERACTIVE_PAGES_REPORTS_FAILED,
  FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS, FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_SUCCEEDED, FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_FAILED,
  FETCHING_STORYBOARD_INTERACTIONS_REPORTS, FETCHING_STORYBOARD_INTERACTIONS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_INTERACTIONS_REPORTS_FAILED,
  FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES, FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_SUCCEEDED, FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_FAILED,
  FETCHING_STORYBOARD_SESSIONS_TIME_SERIES, FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_SUCCEEDED, FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_FAILED,
  FETCHING_STORYBOARD_LEADS_TIME_SERIES, FETCHING_STORYBOARD_LEADS_TIME_SERIES_SUCCEEDED, FETCHING_STORYBOARD_LEADS_TIME_SERIES_FAILED,
  FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS, FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_SUCCEEDED, FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_FAILED,
  FETCHING_INTERACTIVE_DOWNLOADS_TRENDS, FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_SUCCEEDED, FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_FAILED,
  FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS, FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_SUCCEEDED, FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_FAILED,
  INVALIDATE_STORYBOARD_STATE,

  INITIATE_PPT_UPLOAD_FOR_STORYBOARD, UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS,
  CREATE_STORYBOARD_FROM_PPT_REQUEST, CREATING_STORYBOARD_FROM_PPT_SUCCEEDED, CREATING_STORYBOARD_FROM_PPT_FAILED,

  UNPUBLISH_PAGE_REQUEST, UNPUBLISHING_PAGE_SUCCEEDED, UNPUBLISHING_PAGE_FAILED, INVALIDATE_UNPUBLISH_PAGE,
  FETCHING_PAGE_SUCCEEDED, FETCHING_GATING_SUCCEEDED, ADDING_STORYBOARD_TO_LIST_SUCCEEDED,

  UPDATE_APPEARANCE_REQUEST,

  FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE, FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE_FAILED,
  FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE, FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_FAILED,
  FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE, FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_FAILED,
  FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE, FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_FAILED,
  FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE, FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_FAILED,
  FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE, FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_FAILED,
  INVALIDATE_STORYBOARDS_STATE, FETCHING_STORYBOARD_METRICS_REPORTS, FETCHING_STORYBOARD_METRICS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_METRICS_REPORTS_FAILED,
  MAKE_HOME_PAGE_FOR_STORYBOARD, MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED, MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED,
  FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS, FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_FAILED,
  FETCHING_STORYBOARD_ASSETS_ANALYTICS, FETCHING_STORYBOARD_ASSETS_ANALYTICS_SUCCEEDED, FETCHING_STORYBOARD_ASSETS_ANALYTICS_FAILED,

  FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD, FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED, FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_FAILED, INVALIDATE_ASSET_DOWNLOAD_DATA,
  FETCH_REPORTS_DATA_FOR_DOWNLOAD, FETCH_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED, FETCH_REPORTS_DATA_FOR_DOWNLOAD_FAILED, INVALIDATE_DOWNLOAD_DATA, 
  FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE, FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_FAILED,
  FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE, FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_SUCCEEDED, FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_FAILED,
  FETCH_ANALYTICS_CHART_FOR_ASSET, FETCHING_ANALYTICS_CHART_FOR_ASSET_SUCCEEDED, FETCHING_ANALYTICS_CHART_FOR_ASSET_FAILED,
  FETCHING_DOCUMENT_PREVIEW_SUCCEEDED, FETCHING_DOCUMENT_PREVIEW_FAILED,

  REMOVING_STORYBOARD_FROM_LIST, REMOVING_STORYBOARD_FROM_LIST_SUCCEEDED, REMOVING_STORYBOARD_FROM_LIST_FAILED,
  FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD, FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED, FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED,
  FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD, FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED, FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED,
  UPDATING_PAGE_SUCCEEDED, UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED,
  EDITOR_CREATE_WIDGET, EDITOR_DELETE_WIDGET, EDITOR_UPDATE_WIDGET_NAME, 
  CREATE_STORYBOARD_FROM_FIGMA_REQUEST, CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED, CREATING_STORYBOARD_FROM_FIGMA_FAILED,
  FETCH_DOMAINS_REQUEST, FETCHING_DOMAINS_SUCCEEDED, FETCHING_DOMAINS_FAILED,
  FETCH_PAGE_PERFORMANCE_METRICS_REQUEST, FETCHING_PAGE_PERFORMANCE_METRICS_SUCCEEDED, FETCHING_PAGE_PERFORMANCE_METRICS_FAILED,
  FETCH_PAGE_PERFORMANCE_HISTORY_REQUEST, FETCHING_PAGE_PERFORMANCE_HISTORY_SUCCEEDED, FETCHING_PAGE_PERFORMANCE_HISTORY_FAILED, INVALIDATE_PAGE_PERFORMANCE,  UPDATE_HOME_PAGE_FOR_STORYBAORD,
  FETCHING_JOURNEY_REPORTS, FETCHING_JOURNEY_REPORTS_SUCCEEDED, FETCHING_JOURNEY_REPORTS_FAILED,
  UPDATE_STORYBOARD_ITEM, CHANGE_REPORT_TYPE, DISBALE_PAGE_SEEK_INDEXING,
  DISABLE_PAGE_SEEK_INDEXING
} from 'constants/actionTypes';

import { PAGE } from 'constants/widgetTypes';

import shortid from 'shortid';

import { templateReducer } from './templateReducer';

const assetReportsState = {
  loading: false,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
    hasMore: false
  },
  progress: false,
  completed: false
}

const performanceState = {
  loading: false,
  performanceMetrics: null,
  performanceHistory: null
}

const storyboardReportsState = {
  reportType: "ALL",
  summary: {
    loading: false,
    invalidated: true,
    item: {},
    downloads: {
      loading: false,
      invalidated: false,
      items: []
    },
    views: {
      loading: false,
      invalidated: false,
      items: []
    },
    visitors: {
      oading: false,
      invalidated: false,
      items: []
    }
  },
  visitors: {
    loading: false,
    invalidated: true,
    pagination: {
      current: -1,
      totalPages: 1
    },
    items: []
  },
  pages: {
    loading: false,
    invalidated: true,
    pagination: {
      current: -1,
      totalPages: 1
    },
    items: []
  },
  interactions: {
    loading: false,
    invalidated: true,
    pagination: {
      current: -1,
      totalPages: 1
    },
    items: []
  },
  assetAnalytics: {
    loading: false,
    invalidated: true,
    pagination: {
      current: -1,
      totalPages: 1
    },
    items: []
  },
  downloads: {
    loading: false,
    invalidated: false,
    items: []
  },
  sessionTimeSeries: {
    loading: false,
    invalidated: false,
    items: []
  },
  leadTimeSeries: {
    loading: false,
    invalidated: false,
    items: []
  },
  metrics: {
    loading: false,
    invalidated: true,
    item: {}
  },
  download: {
    loading: false,
    invalidated: true,
    pagination: {
      current: -1,
      totalPages: 1,
      hasMore: false
    },
    completed: false,
    progress: false,
    items: []
  },
  analytics: {
    sessions: {
      loading: false,
      items: [],
      error: null
    },
    asset: {
      loading: false,
      items: [],
      error: null
    },
    country: {
      loading: false,
      items: [],
      error: null
    }
  },
  journey: {
    loading: false,
    invalidated: true,
    pagination: {
      current: -1,
      totalPages: 1
    },
    items: []
  }
}

const initialState = {
  loading: false,
  invalidated: false,
  items: [],
  uploads: [],
  pagination: {
    current: 0,
    totalPages: 1
  },
  storyboard: {
    loading: false,
    creating: false,
    updating: false,
    deleting: false,
    deleted: false,
    cloning: false,
    addingUsers: false,
    item: null,
    users: {
      loading: false,
      invalidate: true,
      items: []
    },
    pages: {
      loading: false,
      items: [],
      error: null
    },
    domains:{
      loading: false,
      items: [],
      error: null
    },
    reports: storyboardReportsState,
    assetReports: assetReportsState,
    performance: performanceState
  },
}

const metricsInitialState = {
  loading: false,
  invalidated: false,
  items: [],
  pagination: {
    current: 0,
    totalPages: 1
  }
}

export function storyboardsReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_STORYBOARD_REQUEST:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          creating: true,
          item: null,
          error: null
        }
      }

    case CREATING_STORYBOARD_SUCCEEDED: {

      var items = state.items

      let gatingConfigurations = _.get(action.payload, 'gatingConfigurations', []);
      gatingConfigurations = gatingConfigurations.map(item => {
        return {
          ...item,
          uid: shortid()
        }
      });

      return {
        ...state,
        creating: false,
        items: [action.payload, ...state.items],
        storyboard: {
          ...state.storyboard,
          creating: false,
          item: {
            ...action.payload,
            gatingConfigurations: gatingConfigurations
          },
          error: null
        }
      }
    }

    case CREATING_STORYBOARD_FAILED: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          creating: false,
          error: action.payload
        }
      }
    }

    case UPDATE_STORYBOARD_REQUEST:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          updating: true,
          error: null
        }
      }

    case UPDATING_STORYBOARD_SUCCEEDED: {
      let gatingConfigurations = _.get(action.payload.response, 'gatingConfigurations', []);
      gatingConfigurations = gatingConfigurations.map(item => {
        return {
          ...item,
          uid: shortid()
        }
      });

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          updating: false,
          item: {
            ...action.payload.response,
            gatingConfigurations: gatingConfigurations
          },
          error: null
        }
      }
    }

    case UPDATING_STORYBOARD_FAILED:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          updating: false,
          error: action.payload.error
        }
      }

    case UPDATE_STORYBOARD_ITEM: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            ...action.payload
          }
        }
      }
    }
    
    case FETCH_STORYBOARDS_REQUEST:
      return {
        ...state,
        loading: true,
        invalidated: true,
        query: _.get(action, 'payload.query', ''),
        storyboard: {
          ...state.storyboard,
          error: null
        }
      }

    case FETCHING_STORYBOARDS_SUCCEEDED: {
      const { request, response } = action.payload;
      var records = response.records;
      var items = [];

      if (request.query && state.query !== request.query) {
        return state;
      }

      if (response.currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: response.currentPage,
          totalPages: response.totalPages,
          totalRecordsCount: response.totalRecordsCount
        }
      }
    }


    case FETCHING_STORYBOARDS_FAILED: {
      const { request, response } = action.payload;

      if (state.query !== request.query) {
        return state;
      }

      return {
        ...state,
        loading: false,
        error: response,
        pagination: {
          current: -1,
          totalPages: 1
        }
      }
    }


    case FETCH_STORYBOARD_REQUEST:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: true,
          error: null
        }
      }

    case FETCHING_STORYBOARD_SUCCEEDED:

      let gatingConfigurations = _.get(action.payload, 'gatingConfigurations', []);
      gatingConfigurations = gatingConfigurations.map(item => {
        return {
          ...item,
          uid: shortid()
        }
      });

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: false,
          item: {
            ...action.payload,
            gatingConfigurations: gatingConfigurations
          }
        }
      }

    case FETCHING_STORYBOARD_FAILED:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: false,
          error: action.payload
        }
      }

    case DELETE_STORYBOARD_REQUEST:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          deleting: true,
          deleted: false,
          error: null
        }
      }

    case DELETING_STORYBOARD_SUCCEEDED:
      var items = state.items.filter(item => {
        return item.id !== action.payload;
      })

      return {
        ...state,
        items: items,
        storyboard: {
          ...state.storyboard,
          deleting: false,
          deleted: true,
          item: null
        }
      }

    case DELETING_STORYBOARD_FAILED:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          deleting: false,
          deleted: false,
          error: action.payload.error
        }
      }

    case CLONE_STORYBOARD_REQUEST:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: null,
          cloning: templateReducer
        }
      }

    case CLONING_STORYBOARD_SUCCEEDED: {
      let gatingConfigurations = _.get(action.payload, 'gatingConfigurations', []);
      gatingConfigurations = gatingConfigurations.map(item => {
        return {
          ...item,
          uid: shortid()
        }
      });

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          cloning: false,
          item: {
            ...action.payload,
            gatingConfigurations: gatingConfigurations
          }
        }
      }
    }

    case CLONING_STORYBOARD_FAILED:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          cloning: false,
          error: action.payload.error
        }
      }

    case INITIATE_PPT_UPLOAD_FOR_STORYBOARD: {
      const request = action.payload;
      
      var uploads = [...state.uploads, request];
      uploads = _.uniqBy(uploads, 'id');

      return {
        ...state,
        uploads: uploads
      }
    }

    case UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS: {
      const { id, progress } = action.payload;

      var uploads = state.uploads.map(file => {
        if (file.id === id) {
          return {
            ...file,
            progress: progress
          }
        }

        return file;
      });

      return {
        ...state,
        uploads: uploads
      }
    }

    case CREATE_STORYBOARD_FROM_PPT_REQUEST: {
      const { id } = action.payload;

      var uploads = state.uploads.map(file => {
        if (file.id === id) {
          return {
            ...file,
            processing: true
          }
        }

        return file;
      })

      return {
        ...state,
        uploads: uploads
      }
    }

    case CREATING_STORYBOARD_FROM_PPT_SUCCEEDED: {
      const { id, response } = action.payload;

      var uploads = state.uploads.filter(file => {
        return file.id !== id;
      })

      var items = [response.storyboard, ...state.items];
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        uploads: uploads,
        items: items
      }
    }

    case CREATING_STORYBOARD_FROM_PPT_FAILED: {
      const { id, error } = action.payload;

      var uploads = state.uploads.map(file => {
        if (file.id === id) {
          return {
            ...file,
            processing: false,
            error: error
          }
        }

        return file;
      })

      return {
        ...state,
        uploads: uploads
      }
    }

    case CREATE_STORYBOARD_FROM_FIGMA_REQUEST: {
      const { id, request } = action.payload;

      const newUpload = {
        ...request,
        id: id,
        fileType: 'figma',
        processing: true
      }

      const uploads = [...state.uploads, newUpload];

      return {
        ...state,
        uploads: uploads
      }
    }

    case CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED: {
      const { id, response } = action.payload;

      var uploads = state.uploads.filter(file => {
        return file.id !== id;
      })

      var items = [response.storyboard, ...state.items];
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        uploads: uploads,
        items: items
      }
    }

    case CREATING_STORYBOARD_FROM_FIGMA_FAILED: {
      const { id, error } = action.payload;

      var uploads = state.uploads.map(file => {
        if (file.id === id) {
          return {
            ...file,
            processing: true,
            error: error
          }
        }

        return file;
      })

      return {
        ...state,
        uploads: uploads
      }
    }

    case FETCH_STORYBOARD_USERS: {
      const { id } = action.payload;

      if (id !== _.get(state, 'storyboard.item.id', null)) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            loading: true
          }
        }
      }
    }

    case FETCHING_STORYBOARD_USERS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== _.get(state, 'storyboard.item.id', null)) {
        return state;
      }

      var items = [];

      if (response.currentPage !== 0) {
        items = [...state.storyboard.users.items, ...response.records];
      } else {
        items = response.records
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            invalidated: false,
            loading: false,
            items: items,
            pagination: {
              ...state.storyboard.users.pagination,
              current: response.currentPage,
              totalPages: response.totalPages
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_USERS_FAILED: {
      const { id, error } = action.payload;

      if (id !== _.get(state, 'storyboard.item.id', null)) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            loading: false,
            error: error
          }
        }
      }
    }

    case ADD_USERS_TO_STORYBOARD: {
      const { id } = action.payload;

      if (id !== _.get(state, 'storyboard.item.id', null)) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          addingUsers: true
        }
      }
    }

    case ADD_USERS_TO_STORYBOARD_SUCCEEDED: {
      const { id } = action.payload;

      if (id !== _.get(state, 'storyboard.item.id', null)) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          addingUsers: false
        }
      }
    }

    case ADD_USERS_TO_STORYBOARD_FAILED: {
      const { id, error } = action.payload;

      if (id !== _.get(state, 'storyboard.item.id', null)) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          addingUsers: false,
          addUserError: error
        }
      }
    }

    case UPDATE_STORYBOARD_USER_ACCESS:
      const { id, request } = action.payload;

      var users = state.storyboard.users.items.map(item => {
        if (item.id === id) {
          return {
            ...item,
            updating: true
          }
        }

        return item;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            items: users
          }
        }
      }

    case UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED: {
      const { id, response } = action.payload;

      var users = state.storyboard.users.items.map(item => {
        if (item.id === id) {
          return {
            ...item,
            ...response,
            updating: false,
          }
        }

        return item;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            items: users
          }
        }
      }
    }


    case UPDATE_STORYBOARD_USER_ACCESS_FAILED: {
      const { id, error } = action.payload;

      var users = state.storyboard.users.items.map(item => {
        if (item.id === id) {
          return {
            ...item,
            updating: false,
            error: error
          }
        }

        return item;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            items: users
          }
        }
      }
    }

    case REMOVE_USER_FROM_STORYBOARD: {
      const { id } = action.payload;

      var users = state.storyboard.users.items.map(item => {
        if (item.id === id) {
          return {
            ...item,
            deleting: true
          }
        }

        return item;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            items: users
          }
        }
      }
    }

    case REMOVE_USER_FROM_STORYBOARD_SUCCEEDED: {
      const { id } = action.payload;

      var users = state.storyboard.users.items.filter(item => {
        return item.id !== id;
      });

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            items: users
          }
        }
      }
    }

    case REMOVE_USER_FROM_STORYBOARD_FAILED: {
      const { id, error } = action.payload;

      var users = state.storyboard.users.items.map(item => {
        if (item.id === id) {
          return {
            ...item,
            deleting: false,
            error: error
          }
        }

        return item;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          users: {
            ...state.storyboard.users,
            items: users
          }
        }
      }
    }

    case FETCHING_STORYBOARD_REPORT_SUMMARY: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              loading: true,
              item: {}
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_REPORT_SUMMARY_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              loading: false,
              item: response
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_REPORT_SUMMARY_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              loading: true,
              item: {}
            }
          }
        }
      }
    }

    case FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              loading: false,
              item: response
            }
          }
        }
      }
    }

    case FETCHING_REPORT_SUMMARY_FOR_LANDING_PAGE_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_VISITORS_REPORTS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            visitors: {
              ...state.storyboard.reports.visitors,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_VISITORS_REPORTS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            visitors: {
              ...state.storyboard.reports.visitors,
              loading: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_VISITORS_REPORTS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            visitors: {
              ...state.storyboard.reports.visitors,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            visitors: {
              ...state.storyboard.reports.visitors,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            visitors: {
              ...state.storyboard.reports.visitors,
              loading: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_VISITORS_REPORTS_FOR_LANDING_PAGE_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            visitors: {
              ...state.storyboard.reports.visitors,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGES_REPORTS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGES_REPORTS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              invalidated: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGES_REPORTS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var items = [];

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              invalidated: false,
              chartItems: response.records,
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var items = [];

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              invalidated: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var items = [];

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              invalidated: false,
              chartItems: response.records,
            }
          }
        }
      }
    }

    case FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var items = [];

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            pages: {
              ...state.storyboard.reports.pages,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case UPDATE_APPEARANCE_REQUEST: {
      const { id, appearance } = action.payload;

      const item = state.storyboard.item;
      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...item,
            appearance: appearance
          },
        }
      }
    }

    case FETCHING_STORYBOARD_INTERACTIONS_REPORTS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            interactions: {
              ...state.storyboard.reports.interactions,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_INTERACTIONS_REPORTS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            interactions: {
              ...state.storyboard.reports.interactions,
              loading: false,
              invalidated: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_INTERACTIONS_REPORTS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            interactions: {
              ...state.storyboard.reports.interactions,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          assetReports: {
            ...state.storyboard.assetReports,
            loading: true,
            progress: true,
            completed: false
          }
        }
      }
    }

    case FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED: {
      const { id, response } = action.payload;

      var completed = false;
      var progress = true;

      const hasMoreItems = response.currentPage < response.totalPages - 1;

      if (!hasMoreItems) {
        completed = true;
        progress = false;
      }

      if (id !== state.storyboard.item.id) {
        return state;
      }
      const assetData = _.get(state, 'storyboard.assetReports');

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          assetReports: {
            ...assetData,
            loading: false,
            items: [
              ...assetData.items,
              ...response.records

            ],
            pagination: {
              ...state.pagination,
              current: response.currentPage,
              totalPages: response.totalPages,
              totalRecordsCount: response.totalRecordsCount,
              hasMore: response.currentPage < (response.totalRecordsCount)
            },
            completed: completed,
            progress: progress,
          }
        }
      }
    }

    case FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          assetReports: {
            ...state.storyboard.assetReports,
            loading: false,
            completed: false,
            progress: false,
            error: error
          }
        }
      }
    }

    case FETCHING_STORYBOARD_ASSETS_ANALYTICS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            assetAnalytics: {
              ...state.storyboard.reports.assetAnalytics,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_ASSETS_ANALYTICS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            assetAnalytics: {
              ...state.storyboard.reports.assetAnalytics,
              loading: false,
              invalidated: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_ASSETS_ANALYTICS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            assetAnalytics: {
              ...state.storyboard.reports.assetAnalytics,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            interactions: {
              ...state.storyboard.reports.interactions,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            interactions: {
              ...state.storyboard.reports.interactions,
              loading: false,
              invalidated: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIONS_REPORTS_FOR_LANDING_PAGE_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            interactions: {
              ...state.storyboard.reports.interactions,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            downloads: {
              ...state.storyboard.reports.downloads,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            downloads: {
              ...state.storyboard.reports.downloads,
              loading: false,
              items: response
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            downloads: {
              ...state.storyboard.reports.downloads,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_LEADS_TIME_SERIES: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            leadTimeSeries: {
              ...state.storyboard.reports.leadTimeSeries,
              items: [],
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_LEADS_TIME_SERIES_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            leadTimeSeries: {
              ...state.storyboard.reports.leadTimeSeries,
              loading: false,
              items: response
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_LEADS_TIME_SERIES_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            leadTimeSeries: {
              ...state.storyboard.reports.leadTimeSeries,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_SESSIONS_TIME_SERIES: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            sessionTimeSeries: {
              ...state.storyboard.reports.sessionTimeSeries,
              items: [],
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            sessionTimeSeries: {
              ...state.storyboard.reports.sessionTimeSeries,
              loading: false,
              items: response
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            sessionTimeSeries: {
              ...state.storyboard.reports.sessionTimeSeries,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            views: {
              ...state.storyboard.reports.views,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            views: {
              ...state.storyboard.reports.views,
              loading: false,
              items: response
            }
          }
        }
      }
    }

    case FETCHING_PAGE_VIEWS_TIME_SERIES_FOR_LANDING_PAGE_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            views: {
              ...state.storyboard.reports.views,
              loading: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              views: {
                ...state.storyboard.reports.summary.views,
                loading: true
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              views: {
                ...state.storyboard.reports.summary.views,
                loading: false,
                items: response
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_PAGE_VIEWS_TRENDS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              views: {
                ...state.storyboard.reports.summary.views,
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_DOWNLOADS_TRENDS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              downloads: {
                ...state.storyboard.reports.summary.downloads,
                loading: true
              }
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              downloads: {
                ...state.storyboard.reports.summary.downloads,
                loading: false,
                items: response
              }
            }
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              views: {
                ...state.storyboard.reports.summary.views,
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              visitors: {
                ...state.storyboard.reports.summary.visitors,
                loading: true
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              visitors: {
                ...state.storyboard.reports.summary.visitors,
                loading: false,
                items: response
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,

          reports: {
            ...state.storyboard.reports,
            summary: {
              ...state.storyboard.reports.summary,
              visitors: {
                ...state.storyboard.reports.summary.visitors,
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case INVALIDATE_STORYBOARDS_STATE: {
      return {
        ...state,
        loading: false,
        invalidated: false,
        items: [],
        pagination: {
          current: 0,
          totalPages: 1
        }
      }
    }
    case INVALIDATE_STORYBOARD_STATE: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: false,
          creating: false,
          updating: false,
          deleting: false,
          deleted: false,
          cloning: false,
          item: null,
          addingUsers: false,
          users: {
            loading: false,
            invalidate: true,
            items: []
          }
        }
      }
    }

    case INVALIDATE_DOWNLOAD_DATA: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            download: {
              loading: false,
              invalidated: true,
              pagination: {
                current: -1,
                totalPages: 1,
                hasMore: false
              },
              completed: false,
              progress: false,
              items: []
            }
          }
        }
      }
    }

    case INVALIDATE_ASSET_DOWNLOAD_DATA: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          assetReports: {
            loading: false,
            items: [],
            pagination: {
              current: -1,
              totalPages: 1,
              hasMore: false
            },
            progress: false,
            completed: false
          }
        }
      }
    }

    case UNPUBLISH_PAGE_REQUEST: {
      const { id } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            page: {
              ...state.storyboard.item.page,
              unpublish: {
                unpublishing: true,
                success: false
              }
            }
          }
        }
      }
    }

    case UNPUBLISHING_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            page: {
              ...state.storyboard.item.page,
              published: false,
              unpublish: {
                unpublishing: false,
                success: true
              }
            }
          }
        }
      }
    }

    case UNPUBLISHING_PAGE_FAILED: {
      const { id, error } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            page: {
              ...state.storyboard.item.page,
              unpublish: {
                unpublishing: false,
                success: false,
                error: error
              }
            }
          }
        }
      }
    }

    case INVALIDATE_UNPUBLISH_PAGE:

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            page: {
              ...state.storyboard.item.page,
              published: false,
              unpublish: {
                unpublishing: false,
                success: false
              }
            }
          }
        }
      }

    case FETCHING_GATING_SUCCEEDED: {
      const { storyboard } = action.payload.response;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...storyboard,
            ...state.storyboard.item,
            gatingConfigurations: _.get(state, 'storyboard.item.gatingConfigurations', [])
          }
        }
      }
    }

    case FETCHING_PAGE_SUCCEEDED: {
      const { storyboard } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...storyboard,
            ...state.storyboard.item,
            gatingConfigurations: _.get(state, 'storyboard.item.gatingConfigurations', [])
          }
        }
      }
    }

    case ADDING_STORYBOARD_TO_LIST_SUCCEEDED: {
      var { source, storyboard } = action.payload;

      if (!source) {
        return state;
      }

      var items = state.items.filter(item => {
        return item.id !== storyboard.id;
      })

      return {
        ...state,
        items: items
      }
    }

    case REMOVING_STORYBOARD_FROM_LIST:
      return state;

    case REMOVING_STORYBOARD_FROM_LIST_SUCCEEDED: {
      var { storyboardId } = action.payload;

      var items = state.items.filter(item => {
        return item.id !== storyboardId;
      })

      return {
        ...state,
        items: items
      }
    }

    case REMOVING_STORYBOARD_FROM_LIST_FAILED:
      return state;

    case FETCHING_STORYBOARD_METRICS_REPORTS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            metrics: {
              ...state.storyboard.reports.metrics,
              [request.metricType]: {
                ...metricsInitialState,
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_METRICS_REPORTS_SUCCEEDED: {
      const { id, response, type } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var metricsState = state.storyboard.reports.metrics[type] || metricsInitialState;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            metrics: {
              ...state.storyboard.reports.metrics,
              [type]: {
                ...metricsState,
                loading: false,
                items: [...response.records],
                pagination: {
                  ...state.storyboard.reports.metrics[type].pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_METRICS_REPORTS_FAILED: {
      const { id, error, type } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            metrics: {
              ...state.storyboard.reports.metrics,
              [type]: {
                ...metricsInitialState,
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            metrics: {
              ...state.storyboard.reports.metrics,
              [request.metricType]: {
                ...metricsInitialState,
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_SUCCEEDED: {
      const { id, response, type } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var metricsState = state.storyboard.reports.metrics[type] || metricsInitialState;
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            metrics: {
              ...state.storyboard.reports.metrics,
              [type]: {
                ...metricsState,
                loading: false,
                chartItems: [...response.records]
              }
            }
          }
        }
      }
    }

    case FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_FAILED: {
      const { id, error, type } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            metrics: {
              ...state.storyboard.reports.metrics,
              [type]: {
                ...metricsInitialState,
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case MAKE_HOME_PAGE_FOR_STORYBOARD:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: false
        }
      }

    case MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED:
      var { page, response } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: false,
          item: response
        }
      }

    case MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: false,
          error: action.payload.error
        }
      }

    case UPDATE_HOME_PAGE_FOR_STORYBAORD:
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          loading: false,
          item: {
            ...state.storyboard.item,
            page: action.payload
          }
        }
      }

    case FETCH_REPORTS_DATA_FOR_DOWNLOAD: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            download: {
              ...state.storyboard.reports.download,
              loading: true,
              progress: true,
              completed: false
            }
          }
        }
      }
    }

    case FETCH_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED: {
      const { id, response } = action.payload;
      var completed = false;
      var progress = true;

      const hasMoreItems = response.currentPage < response.totalPages - 1;

      if (!hasMoreItems) {
        completed = true;
        progress = false;
      }

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var items = [...state.storyboard.reports.download.items, ...response.records]

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            download: {
              ...state.storyboard.reports.download,
              loading: false,
              items: items,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount,
                hasMore: response.currentPage < (response.totalRecordsCount)
              },
              completed: completed,
              progress: progress,
            }
          }
        }
      }
    }

    case FETCH_REPORTS_DATA_FOR_DOWNLOAD_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            download: {
              ...state.storyboard.reports.download,
              loading: false,
              completed: false,
              progress: false,
              error: error
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE: {
      const { request, type } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              [type]: {
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_SUCCEEDED: {
      const { response, type, id } = action.payload;

      var orderedPageArray = state.storyboard.reports.analytics.pages.items.map(item => {
        return item.uid;
      });

      var sortedItems = _.sortBy(response.pageAnalytics, function (item) {
        return orderedPageArray.indexOf(item.id)
      });

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              [type]: {
                loading: false,
                items: {
                  ...state.storyboard.reports.analytics[type].items,
                  [response.typeId]: sortedItems
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_FAILED: {
      const { id, error, type } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              [type]: {
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE: {
      const { request, type } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              [type]: {
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_SUCCEEDED: {
      const { response, type, id } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var orderedPageArray = state.storyboard.reports.analytics.pages.items.map(item => {
        return item.id;
      });

      var sortedItems = _.sortBy(response.pageAnalytics, function (item) {
        return orderedPageArray.indexOf(item.id)
      });

      sortedItems = sortedItems.map((item) => {
        let index = _.indexOf(sortedItems, item, 0)

        const page = state.storyboard.reports.analytics.pages.items[index]

        var newItem = {
          ...item,
          name: page.name
        }

        return newItem;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              [type]: {
                loading: false,
                items: {
                  ...state.storyboard.reports.analytics[type].items,
                  [response.typeId]: sortedItems
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_FAILED: {
      const { id, error, type } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              [type]: {
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case FETCH_ANALYTICS_CHART_FOR_ASSET: {

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              asset: {
                loading: true
              }
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_ASSET_SUCCEEDED: {
      const { response, id } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              asset: {
                loading: false,
                items: {
                  ...state.storyboard.reports.analytics.asset.items,
                  [id]: response
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_ANALYTICS_CHART_FOR_ASSET_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              asset: {
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }

    case FETCHING_DOCUMENT_PREVIEW_SUCCEEDED: {
      const { response, assetMappingId, asset } = action.payload;

      const currentAsset = _.get(state, `storyboard.reports.analytics.asset.items[${assetMappingId}]`, []);
      const pages = _.get(response, 'pages', []);
      const pageLength = _.get(asset, 'metadata.pages');

      const addPreviewImages = (currentAsset, pages, pageLength) => {
        return Array.from({ length: pageLength }, (_, index) => {
            const existingItem = currentAsset.find(item => item.index === index + 1);
            return existingItem ? existingItem : { index: index + 1, totalTime: 0, count: 0 };
        }).map(item => {
            const matchingItem = _.find(pages, { index: item.index - 1 });
            return matchingItem ? { ...item, thumbnail: _.get(matchingItem, 'background.full', null) } : item;
        });
      };
  
      const updatedArray = addPreviewImages(currentAsset, pages, pageLength);

      const updatedItem = {
        ...state.storyboard.reports.analytics.asset.items,
        [assetMappingId]: updatedArray
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              asset: {
                ...state.storyboard.reports.analytics.asset,
                items: updatedItem,
                error: null
              }
            }
          }
        }
      }
    }

    case FETCHING_DOCUMENT_PREVIEW_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              asset: {
                ...state.storyboard.reports.analytics.asset,
                error: error
              }
            }
          }
        }
      }
    }

    case FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD: {
      const { storyboard } = action.payload;

      if (storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              pages: {
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED: {
      const { response, storyboard } = action.payload;

      if (storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              pages: {
                ...state.storyboard.reports.analytics.pages,
                loading: false,
                items: response.records
              }
            }
          }
        }
      }
    }

    case FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED: {
      const { storyboard, error } = action.payload;

      if (storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            analytics: {
              ...state.storyboard.reports.analytics,
              pages: {
                ...state.storyboard.reports.analytics.pages,
                loading: false,
                error: error
              }
            }
          }
        }
      }
    }


    case FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD: {
      const { storyboard } = action.payload;

      if (storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          pages: {
            ...state.storyboard.pages,
            loading: true,
          }
        }
      }
    }

    case FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED: {
      const { response, request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          pages: {
            ...state.storyboard.pages,
            loading: false,
            items: response
          }
        }
      }
    }

    case FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED: {
      const { request, error } = action.payload;

      if (!request?.storyboard || (request.storyboard !== state.storyboard.item.id)) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          pages: {
            ...state.storyboard.pages,
            loading: false,
            error: error
          }
        }
      }
    }

    case CREATE_GATING_CONFIG_REQUEST: {
      const request = action.payload;

      var gatingConfigs = _.get(state, 'storyboard.item.gatingConfigurations', []) || [];

      if(request.smart) {
        gatingConfigs = [request, ...gatingConfigs];
      } else {
        gatingConfigs = [...gatingConfigs, request];
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            gatingConfigurations: gatingConfigs
          },
        }
      }
    }

    case UPDATE_GATING_CONFIG_REQUEST: {
      const { id, request } = action.payload;

      var gatingConfigs = _.get(state, 'storyboard.item.gatingConfigurations', []) || [];
      gatingConfigs = gatingConfigs.map(item => {
        if (item.uid === id) {
          return {
            ...item,
            ...request
          }
        }

        return item;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            gatingConfigurations: gatingConfigs,
            mixpanel: request,
            gatingId: id,
          },
        }
      }
    }

    case DELETE_GATING_CONFIG_REQUEST: {
      const { id } = action.payload;

      var gatingConfigs = _.get(state, 'storyboard.item.gatingConfigurations', []) || [];
      gatingConfigs = gatingConfigs.filter(gating => {
        return id != gating.uid
      });

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            gatingConfigurations: gatingConfigs
          },
        }
      }
    }

    case RESET_GATING_CONFIG_REQUEST: {
      const { gatingConfigs } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            gatingConfigurations: gatingConfigs
          },
        }
      }
    }

    case UPDATING_PAGE_SUCCEEDED:
    case UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED: {
      const { id, response } = action.payload;

      var pageId = _.get(state, 'storyboard.item.page.id', null);
      var passwordProtected = _.get(response, 'storyboard.passwordProtected');

      if (id == pageId) {
        return {
          ...state,
          storyboard: {
            ...state.storyboard,
            item: {
              ...state.storyboard.item,
              page: response,
              passwordProtected: passwordProtected
            },
          }
        }
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            passwordProtected: passwordProtected
          },
        }
      }
    }

    case DISABLE_PAGE_SEEK_INDEXING: {
      const { id }  = action.payload;
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          item: {
            ...state.storyboard.item,
            page: {
              ...state.storyboard.item.page,
              seekEnabled: false
            }
          },
        }
      }
    }

    case EDITOR_CREATE_WIDGET: {
      const { widgets } = action.payload;

      if (!widgets || _.size(widgets) === 0) {
        return state;
      }

      var widget = widgets[0];

      const storyboardType = _.get(state, 'storyboard.item.type');
      if (storyboardType !== 'INTERACTIVE_CONTENT' || widget.type !== PAGE) {
        return state;
      }

      var pages = _.get(state, 'storyboard.pages.items', []);
      var page = pages[0].page;

      widget = {
        ...widget,
        page: page
      }

      pages = [...pages, widget];

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          pages: {
            ...state.storyboard.pages,
            items: pages
          }
        }
      }
    }

    case EDITOR_DELETE_WIDGET: {
      const { widgets } = action.payload;

      var widget = widgets[0];

      const storyboardType = _.get(state, 'storyboard.item.type');
      if (storyboardType !== 'INTERACTIVE_CONTENT') {
        return state;
      }

      var pages = _.get(state, 'storyboard.pages.items', []);
      pages = pages.filter(item => item.uid != widget);

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          pages: {
            ...state.storyboard.pages,
            items: pages
          }
        }
      }
    }

    case EDITOR_UPDATE_WIDGET_NAME: {
      const { widget, name } = action.payload;

      var pages = _.get(state, 'storyboard.pages.items', []);
      pages = pages.map(item => {
        if (item.uid === widget) {
          return {
            ...item,
            name: name
          }
        }

        return item;
      })

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          pages: {
            ...state.storyboard.pages,
            items: pages
          }
        }
      }
    }


    case FETCH_DOMAINS_REQUEST: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          domains: {
            ...state.storyboard.domains,
            loading: true,
          }
        }
      }
    }

    case FETCHING_DOMAINS_SUCCEEDED: {
      const { response, request } = action.payload;
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          domains: {
            ...state.storyboard.domains,
            loading: false,
            items: response
          }
        }
      }
    }

    case FETCHING_DOMAINS_FAILED: {
      const { request, error } = action.payload;
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          domains: {
            ...state.storyboard.domains,
            loading: false,
            error: error
          }
        }
      }
    }

    case FETCH_PAGE_PERFORMANCE_METRICS_REQUEST: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          performance: {
            ...state.storyboard.performance,
            performanceMetrics: {
              ...state.storyboard.performance.performanceMetrics,
              loading: true,
              items: null,
              error: null
            }
          }
        }
      }
    }

    case FETCHING_PAGE_PERFORMANCE_METRICS_SUCCEEDED: {
      const { response } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          performance: {
            ...state.storyboard.performance,
            performanceMetrics: {
              ...state.storyboard.performance.performanceMetrics,
              loading: false,
              items: response
            }
          }
        }
      }
    }

    case FETCHING_PAGE_PERFORMANCE_METRICS_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          performance: {
            ...state.storyboard.performance,
            performanceMetrics: {
              ...state.storyboard.performance.performanceMetrics,
              loading: false,
              items: [],
              error: error
            }
          }
        }
      }
    }

    case FETCH_PAGE_PERFORMANCE_HISTORY_REQUEST: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          performance: {
            ...state.storyboard.performance,
            performanceHistory: {
              ...state.storyboard.performance.performanceHistory,
              loading: true,
              items: [],
              error: null
            }
          }
        }
      }
    }

    case FETCHING_PAGE_PERFORMANCE_HISTORY_SUCCEEDED: {
      const { response } = action.payload;

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          performance: {
            ...state.storyboard.performance,
            performanceHistory: {
              ...state.storyboard.performance.performanceHistory,
              loading: false,
              items: response
            }
          }
        }
      }
    }

    case FETCHING_PAGE_PERFORMANCE_HISTORY_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          performance: {
            ...state.storyboard.performance,
            performanceHistory: {
              ...state.storyboard.performance.performanceHistory,
              loading: false,
              items: [],
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_PAGE_PERFORMANCE: {
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          performance: {
            performanceMetrics: null,
            performanceHistory: null
          }
        }
      }
    }

    case FETCHING_JOURNEY_REPORTS: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            journey: {
              ...state.storyboard.reports.journey,
              loading: true
            }
          }
        }
      }
    }

    case FETCHING_JOURNEY_REPORTS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            journey: {
              ...state.storyboard.reports.journey,
              loading: false,
              invalidated: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
        }
      }
    }

    case FETCHING_JOURNEY_REPORTS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard.item.id) {
        return state;
      }

      var items = [];

      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            journey: {
              ...state.storyboard.reports.journey,
              loading: false,
              error: error
            }
          }
        }
      }
    }
    case CHANGE_REPORT_TYPE: {
      const { reportType } = action.payload
      return {
        ...state,
        storyboard: {
          ...state.storyboard,
          reports: {
            ...state.storyboard.reports,
            reportType
          }
        }
      }
    }

    default:
      return state;
  }
}